import { TableDescriptions } from '../../../@types/interfaces/table-interface';

export const ColumsTableAnalyticAdapter: TableDescriptions[] = [
  { ordination: { ordinationName: 'ID', ordinationValue: '' }, align: 'center', order: 1, id: 1, dataField: 'id', text: 'ID', hidden: false, fixed: true },
  {
    ordination: { ordinationName: 'FILIAL', ordinationValue: '' },
    align: 'center',
    order: 2,
    id: 2,
    dataField: 'filial',
    columnName: 'filial',
    text: 'Fil',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'FILIAL_DESCRICAO', ordinationValue: '' },
    align: 'left',
    order: 3,
    id: 3,
    dataField: 'nomeFantasia',
    columnName: 'nomeFantasia',
    text: 'Filial Descrição',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'BASE', ordinationValue: '' },
    align: 'center',
    order: 4,
    id: 4,
    dataField: 'base',
    columnName: 'base',
    text: 'Base',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'ID_FABRICANTE', ordinationValue: '' },
    align: 'center',
    order: 5,
    id: 5,
    dataField: 'idFabricante',
    columnName: 'idFabricante',
    text: 'Cód. Fab.',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'CODIGO', ordinationValue: '' },
    align: 'center',
    order: 6,
    id: 6,
    dataField: 'codigo',
    columnName: 'codigo',
    text: 'Sufixo',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'NOME', ordinationValue: '' },
    align: 'left',
    order: 7,
    id: 7,
    dataField: 'nome',
    columnName: 'nome',
    text: 'Descrição',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'ALERTA', ordinationValue: '' },
    align: 'left',
    order: 8,
    id: 8,
    dataField: 'ALERTA',
    text: 'ALERTA',
    hidden: false,
    fixed: true,
  },
  {
    ordination: { ordinationName: 'QUANTIDADE', ordinationValue: '' },
    align: 'center',
    order: 9,
    id: 9,
    dataField: 'quantidade',
    columnName: 'quantidade',
    text: 'Qtd',
    hidden: false,
    fixed: true,
  },
  { align: 'right', order: 10, id: 10, dataField: 'qme', columnName: 'qme', text: 'Qme', hidden: false },
  {
    ordination: { ordinationName: 'MEDIA', ordinationValue: '' },
    align: 'right',
    order: 11,
    id: 11,
    dataField: 'media',
    columnName: 'media',
    text: 'Média',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PARAMETRO_MES', ordinationValue: '' },
    align: 'right',
    order: 12,
    id: 12,
    dataField: 'parametroMes',
    columnName: 'parametroMes',
    text: 'PMês',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'ESTOQUE', ordinationValue: '' },
    align: 'right',
    order: 13,
    id: 13,
    dataField: 'estoque',
    columnName: 'estoque',
    text: 'Est',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PENDENTE', ordinationValue: '' },
    align: 'right',
    order: 14,
    id: 14,
    dataField: 'pendente',
    columnName: 'pendente',
    text: 'Pen',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'BLOQUEADO', ordinationValue: '' },
    align: 'right',
    order: 15,
    id: 15,
    dataField: 'bloqueado',
    columnName: 'bloqueado',
    text: 'Bloq',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'TRANSITO', ordinationValue: '' },
    align: 'right',
    order: 16,
    id: 16,
    dataField: 'transito',
    columnName: 'transito',
    text: 'Tran',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'EXCESSO', ordinationValue: '' },
    align: 'right',
    order: 17,
    id: 17,
    dataField: 'excesso',
    columnName: 'excesso',
    text: 'Exc',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'PONTUACAO', ordinationValue: '' },
    align: 'right',
    order: 18,
    id: 18,
    dataField: 'pontuacao',
    columnName: 'pontuacao',
    text: 'Ppt',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'CURVA', ordinationValue: '' },
    align: 'left',
    order: 19,
    id: 19,
    dataField: 'curva',
    columnName: 'curva',
    text: 'Cvf',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'NOVA_CURVA', ordinationValue: '' },
    align: 'left',
    order: 20,
    id: 20,
    dataField: 'novaCurva',
    columnName: 'novaCurva',
    text: 'NCvf',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'STATUS', ordinationValue: '' },
    align: 'left',
    order: 21,
    id: 21,
    dataField: 'status',
    columnName: 'status',
    text: 'Status',
    hidden: false,
  },
  {
    ordination: { ordinationName: 'VALOR_PEDIDO', ordinationValue: '' },
    align: 'right',
    order: 22,
    id: 22,
    dataField: 'valorPedido',
    columnName: 'valorPedido',
    text: 'Valor Pedido',
    hidden: false,
    numberFormat: 'currency',
  },
  {
    ordination: { ordinationName: 'CUSTO_MEDIO', ordinationValue: '' },
    align: 'right',
    order: 23,
    id: 23,
    dataField: 'custoMedio',
    columnName: 'custoMedio',
    text: 'Cst Méd',
    hidden: true,
    numberFormat: 'currency',
  },
  {
    ordination: { ordinationName: 'ULTIMA_VENDA', ordinationValue: '' },
    align: 'right',
    order: 24,
    id: 24,
    dataField: 'ultimaVenda',
    columnName: 'ultimaVenda',
    text: 'Ult Ven',
    hidden: true,
    typeField: 'dateTime',
  },
  {
    ordination: { ordinationName: 'ULTIMA_COMPRA', ordinationValue: '' },
    align: 'right',
    order: 25,
    id: 25,
    dataField: 'ultimaCompra',
    columnName: 'ultimaCompra',
    text: 'Ult Com',
    hidden: true,
    typeField: 'dateTime',
  },
  {
    ordination: { ordinationName: 'ESTOQUE_PENDENTE', ordinationValue: '' },
    align: 'right',
    order: 26,
    id: 26,
    dataField: 'estoquePendente',
    columnName: 'estoquePendente',
    text: 'Dias Pend',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_PROJETADO', ordinationValue: '' },
    align: 'right',
    order: 27,
    id: 27,
    dataField: 'estoqueProjetado',
    columnName: 'estoqueProjetado',
    text: 'Dias Proj',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_FUTURO', ordinationValue: '' },
    align: 'right',
    order: 28,
    id: 28,
    dataField: 'estoqueFuturo',
    columnName: 'estoqueFuturo',
    text: 'Dias Futuro',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'CUSTO_MEDIO_X_ESTOCAGEM', ordinationValue: '' },
    align: 'right',
    order: 29,
    id: 29,
    dataField: 'custoMedioXEstocagem',
    columnName: 'custoMedioXEstocagem',
    text: 'Cst. Med X Est',
    hidden: true,
    numberFormat: 'currency',
  },
  {
    ordination: { ordinationName: 'CUSTO_MEDIO_X_EXC', ordinationValue: '' },
    align: 'right',
    order: 30,
    id: 30,
    dataField: 'custoMedioXExc',
    columnName: 'custoMedioXExc',
    text: 'Cst. Med X Exc',
    hidden: true,
    numberFormat: 'currency',
  },
  {
    ordination: { ordinationName: 'PERC_VARIACAO', ordinationValue: '' },
    align: 'right',
    order: 31,
    id: 31,
    dataField: 'percVariacao',
    columnName: 'percVariacao',
    text: 'Var % Prç Rep x Cst Méd',
    hidden: false,
    numberFormat: 'percent',
  },
  { align: 'center', order: 32, id: 32, dataField: 'siglaFilial', columnName: 'siglaFilial', text: 'Filial', hidden: true },
  { align: 'center', order: 33, id: 33, dataField: 'observacao', text: 'Observação', hidden: false, fixed: true },
  {
    ordination: { ordinationName: 'BLOQUEADO_OSS', ordinationValue: '' },
    align: 'center',
    order: 34,
    id: 34,
    dataField: 'bloqueadoOrdemServico',
    columnName: 'bloqueadoOrdemServico',
    text: 'Bloqueado Ordem Servico',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'ESTOQUE_ATUAL', ordinationValue: '' },
    align: 'right',
    order: 35,
    id: 35,
    dataField: 'estoqueAtual',
    columnName: 'estoqueAtual',
    text: 'Dias Estoque Atual',
    hidden: true,
  },
  {
    ordination: { ordinationName: 'PRECO_REPOSICAO', ordinationValue: '' },
    align: 'right',
    order: 36,
    id: 36,
    dataField: 'precoReposicao',
    columnName: 'precoReposicao',
    text: 'Preço Reposição',
    hidden: true,
    typeField: 'monetary',
  },
  { align: 'center', order: 37, id: 37, dataField: 'demandas', columnName: 'demandas', text: 'Demandas', hidden: true },
  { align: 'center', order: 38, id: 38, dataField: 'alterado', text: 'Alterado', hidden: false, fixed: true },
  { align: 'right', order: 39, id: 39, dataField: 'bloquadoCompra', columnName: 'bloquadoCompra', text: 'BloqCompra', hidden: true, fixed: true },
  {
    ordination: { ordinationName: 'PRECO_VENDA', ordinationValue: '' },
    align: 'right',
    order: 40,
    id: 40,
    dataField: 'precoVenda',
    columnName: 'precoVenda',
    text: 'Prç Vnd',
    hidden: true,
    typeField: 'monetary',
  },
  {
    ordination: { ordinationName: 'PRECO_GARANTIA', ordinationValue: '' },
    align: 'right',
    order: 41,
    id: 41,
    dataField: 'precoGarantia',
    columnName: 'precoGarantia',
    text: 'Prç Gar',
    hidden: true,
    typeField: 'monetary',
  },
  {
    ordination: { ordinationName: 'LOCACAO', ordinationValue: '' },
    align: 'right',
    order: 42,
    id: 42,
    dataField: 'locacao',
    columnName: 'locacao',
    text: 'Locação',
    hidden: true,
  },
  {
    align: 'right',
    order: 43,
    id: 43,
    dataField: 'custoMedioXBloq',
    columnName: 'custoMedioXBloq',
    text: 'Cst.Med x Bloq.',
    hidden: true,
    typeField: 'monetary',
  },
  {
    ordination: { ordinationName: 'GRUPO_DESCONTO', ordinationValue: '' },
    align: 'center',
    order: 44,
    id: 44,
    dataField: 'grupoDesconto',
    columnName: 'grupoDesconto',
    text: 'Grupo Desconto',
    hidden: true,
  },
];
